{
  "room": {
    "id": "showroom-fresh-air-lab",
    "name": "新风空调仿真展厅",
    "area": 40,
    "height": 3,
    "spaceType": "meeting",
    "thermalMassKjPerM2K": 38,
    "envelopeUaWPerM2K": 1.2,
    "lightingWPerM2": 8,
    "equipmentWPerM2": 10,
    "solarWPerM2": 4,
    "occupantSensibleW": 75,
    "occupantMoistureKgPerHour": 0.055,
    "co2GenerationLitersPerSecond": 0.0045
  },
  "baseline": {
    "outdoorTemp": 25,
    "indoorTemp": 24,
    "outdoorCo2": 400,
    "humidity": 50,
    "outdoorHumidity": 60
  },
  "hvac": {
    "setpoint": 24,
    "minimumSupplyAirChanges": 4,
    "maximumSupplyAirChanges": 15,
    "designCoolingDeltaT": 8,
    "designHeatingDeltaT": 11,
    "coolingSupplyTemp": 16,
    "coolingCoilDewPoint": 12,
    "heatingSupplyTemp": 35,
    "pid": {
      "kp": 0.22,
      "ki": 0.028,
      "kd": 0.06,
      "derivativeFilterMinutes": 0.75,
      "antiWindupGain": 0.25,
      "integralDeadband": 0.1,
      "controlStepMinutes": 0.25,
      "outputMin": -1,
      "outputMax": 1,
      "modeEnterError": 0.3,
      "modeExitError": 0.1,
      "modeEnterOutput": 0.05,
      "modeExitOutput": 0.02,
      "modeMinHoldMinutes": 3,
      "closedValveThreshold": 2,
      "minFanFrequency": 20,
      "maxFanFrequency": 50,
      "fanRampHzPerMinute": 3,
      "valveOpenRampPercentPerMinute": 12,
      "valveCloseRampPercentPerMinute": 15
    }
  },
  "spaceTypes": {
    "office": {
      "label": "办公室",
      "peopleOutdoorAirM3h": 25,
      "areaOutdoorAirM3h": 1.1
    },
    "meeting": {
      "label": "会议 / 展示空间",
      "peopleOutdoorAirM3h": 30,
      "areaOutdoorAirM3h": 1.1
    },
    "retail": {
      "label": "商业 / 商超空间",
      "peopleOutdoorAirM3h": 20,
      "areaOutdoorAirM3h": 2
    }
  },
  "stability": {
    "windowMinutes": 20,
    "temperatureRate": 0.03,
    "co2Rate": 2
  },
  "comfort": {
    "temperature": {
      "weight": 0.4,
      "ideal": 24,
      "breakpointDeviation": 2,
      "innerPenaltyPerDegree": 12,
      "outerPenaltyPerDegree": 18
    },
    "co2": {
      "weight": 0.3,
      "ideal": 400,
      "acceptable": 800,
      "critical": 1500,
      "zeroScore": 2500,
      "acceptableScore": 85,
      "criticalScore": 25
    },
    "humidity": {
      "weight": 0.3,
      "ideal": 50,
      "breakpointDeviation": 5,
      "innerPenaltyPerPercent": 1.2,
      "outerPenaltyPerPercent": 3.4
    }
  }
}
